<template>
    <h2 align="center"> 
        Das solltest du hier eigentlich nicht sehen....
    </h2>

</template>

<script>
  export default {
    name: 'Logout',
     async created() {
          this.$store.dispatch('doLogout');
          this.$router.push('/login')
      }
    }
</script>
